<template>
    <div class="home">  
        <div class="row mb-5"> 
            <div class="col-12 col-md-6  mb-10">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Analista de Dados e Desenvolvedor</h3> 
                    </div>
                    <div class="card-body">
                        RENATO PEREIRA LEOPOLDO  <br><br>
                        Responsável pela definição e avaliação e migração dos dados utilizados, juntamente com a correção de incosistências. <br><br> 
                    </div> 
                </div>
            </div> 
            <div class="col-12 col-md-6 mb-10">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Desenvolvedor Backend e Frontend</h3> 
                    </div>
                    <div class="card-body">
                        BRUNO MANZOLI DO NASCIMENTO  <br><br>
                        Programador responsável pela arquitetura, modelagem e desenvolvimento do sistema.<br><br> 
                    </div> 
                </div>
            </div> 
        </div> 
    </div>
</template>

<script lang="ts">
 
    import { Options, Vue  } from "vue-class-component"; 
    
    @Options({
        name: "Equipe",
        components: { },  
    }) 
    export default class Equipe extends Vue {
  
    } 

</script>
